module.exports = __webpack_public_path__ + "img/保存.93c25fa2.svg";